import { Routes, RouterModule } from '@angular/router';
import { ScheduleTriggerHistoryComponent } from './scheduletriggerhistory.component';

const routes: Routes = [
    {
        path: '',
        component: ScheduleTriggerHistoryComponent
    },
];

export const ScheduleTriggerHistoryRoutes = RouterModule.forChild(routes);
